import { MKT } from '../marketing.design';

// Extende a linguagem visual compartilhada do Marketing (MktCompactHeader,
// stats, tabs, table). Sem chrome do Ads Manager da Meta.
//
// A tabela de anuncios nao usa MKT.table.row (flex): as 9 colunas precisam
// alinhar entre cabecalho, linhas e a linha de totais, entao aqui e grid com
// um template unico (`gridCols`) compartilhado pelos tres.
// Ordem: nome | status | criado em | resultados | custo/result. | gasto | m5 | m6 | orcamento
const GRID_COLS = 'grid-cols-[minmax(200px,2.2fr)_130px_95px_minmax(100px,1fr)_minmax(105px,1fr)_minmax(105px,1fr)_minmax(95px,1fr)_85px_120px]';

// Nove colunas nao cabem em tela estreita: o card rola na horizontal em vez de
// espremer os numeros ate quebrarem a linha.
const MIN_WIDTH = 'min-w-[1080px]';

export const MKT_ADS_DESIGN = {
    ...MKT,

    capabilityBanner: {
        container: 'flex items-start gap-3 bg-amber-50 dark:bg-amber-500/10 border border-amber-200 dark:border-amber-500/25 rounded-xl px-4 py-3 mb-6',
        icon: 'text-amber-600 dark:text-amber-400 flex-shrink-0 mt-0.5',
        title: 'text-sm font-semibold text-amber-900 dark:text-amber-300',
        subtitle: 'text-xs text-amber-700 dark:text-amber-400/90 mt-0.5',
        action: 'text-xs font-semibold text-amber-900 dark:text-amber-300 underline hover:no-underline cursor-pointer flex-shrink-0 whitespace-nowrap'
    },

    // Heroi de conexao: substitui o painel inteiro enquanto nao ha conta de
    // anuncios utilizavel. KPIs zerados e abas em 0 nao dizem nada nesse
    // estado, e a unica acao possivel e conectar — entao a tela vira o convite
    // + os tres passos ate os dados aparecerem.
    connectHero: {
        card: 'bg-card rounded-xl border border-border px-6 py-14 md:py-16 flex flex-col items-center text-center',
        iconBox: 'w-16 h-16 rounded-2xl bg-[#1877f2]/10 flex items-center justify-center mb-5',
        title: 'text-xl font-bold text-foreground tracking-tight',
        subtitle: 'text-sm text-muted-foreground mt-2 max-w-md leading-relaxed',
        cta: 'inline-flex items-center gap-2 mt-6 h-10 px-5 bg-primary hover:bg-primary/90 text-primary-foreground text-sm font-semibold rounded-lg transition-all active:transform active:scale-95',
        steps: 'grid grid-cols-1 sm:grid-cols-3 gap-3 mt-10 w-full max-w-3xl text-left',
        step: 'flex items-start gap-3 bg-muted/50 rounded-xl px-4 py-3.5',
        stepNumber: 'flex items-center justify-center flex-shrink-0 w-5 h-5 rounded-full bg-violet-100 dark:bg-violet-500/20 text-[11px] font-bold text-violet-700 dark:text-violet-300 mt-px',
        stepText: 'text-xs text-muted-foreground leading-[1.55]',
        footnote: 'flex items-center gap-1.5 text-xs text-muted-foreground/80 mt-7',
        // Botao "Conectar Meta" da barra de topo — o mesmo nos dois estados da
        // tela (painel com pendencia de escopo e heroi de conexao).
        headerCta: 'flex items-center gap-2 h-9 px-4 bg-primary hover:bg-primary/90 text-primary-foreground text-xs font-medium rounded-lg transition-all',
    },

    // Segmented control de periodo (header da listagem e card de desempenho).
    segmented: {
        container: 'flex items-center gap-0.5 bg-muted rounded-lg p-0.5',
        item: 'px-2.5 py-1.5 text-xs font-medium rounded-md text-muted-foreground hover:text-foreground transition-colors whitespace-nowrap',
        itemActive: 'px-2.5 py-1.5 text-xs font-semibold rounded-md bg-card text-foreground shadow-sm whitespace-nowrap'
    },

    // KPI do topo: valor grande + rotulo + subtexto derivado dos mesmos dados.
    kpi: {
        grid: 'grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3 mb-5',
        card: 'bg-card rounded-xl border border-border p-4 flex items-start gap-3.5 transition-shadow duration-300 hover:shadow-lg',
        iconBox: 'w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0',
        body: 'min-w-0 flex flex-col gap-0.5',
        value: 'text-[22px] leading-tight font-bold text-foreground tabular-nums tracking-tight truncate',
        label: 'text-[13px] font-medium text-foreground',
        sub: 'text-xs text-muted-foreground truncate'
    },

    tabsRow: {
        wrapper: 'flex items-center justify-between gap-4 flex-wrap mb-4',
        container: 'flex items-center gap-1 bg-card border border-border rounded-xl p-1',
        tab: 'flex items-center gap-2 px-3.5 py-2 text-sm font-medium rounded-lg text-muted-foreground hover:text-foreground transition-colors',
        tabActive: 'flex items-center gap-2 px-3.5 py-2 text-sm font-semibold rounded-lg bg-violet-50 dark:bg-violet-500/10 text-violet-700 dark:text-violet-400',
        count: 'text-xs text-muted-foreground/70 tabular-nums',
        countActive: 'text-xs text-violet-400 dark:text-violet-500 tabular-nums',
        note: 'text-xs text-muted-foreground',
        // Chip do escopo de cascata ("Campanha: X ×"), no padrao do Ads
        // Manager: filtro ativo visivel e removivel ao lado das abas.
        scopeChip: 'flex items-center gap-1.5 pl-2.5 pr-1 py-1.5 rounded-lg bg-violet-50 dark:bg-violet-500/10 border border-violet-200 dark:border-violet-500/25 text-xs font-medium text-violet-700 dark:text-violet-300 max-w-[280px]',
        scopeChipLabel: 'text-violet-400 dark:text-violet-500 flex-shrink-0',
        scopeChipName: 'truncate',
        scopeChipX: 'w-4 h-4 rounded flex items-center justify-center hover:bg-violet-100 dark:hover:bg-violet-500/20 text-violet-500 dark:text-violet-400 flex-shrink-0'
    },

    adsTable: {
        gridCols: GRID_COLS,
        scroller: 'overflow-x-auto',
        grid: MIN_WIDTH,
        head: `grid ${GRID_COLS} ${MIN_WIDTH} items-center gap-3 px-5 py-2.5 bg-muted/40 border-b border-border text-[11px] font-semibold uppercase tracking-wider text-muted-foreground`,
        row: `grid ${GRID_COLS} ${MIN_WIDTH} items-center gap-3 px-5 py-3 border-b last:border-b-0 border-border/60 hover:bg-accent/40 transition-colors cursor-pointer text-left w-full`,
        totals: `grid ${GRID_COLS} ${MIN_WIDTH} items-center gap-3 px-5 py-3.5 bg-muted/30 border-t border-border`,
        date: 'text-[12px] text-muted-foreground tabular-nums truncate',
        nameCell: 'flex items-center gap-3 min-w-0 pr-4',
        name: 'text-sm font-semibold text-foreground tracking-tight truncate',
        // Arvore: chevron de expandir + badge do nivel em cada linha.
        chevron: 'w-6 h-6 rounded-md flex items-center justify-center text-muted-foreground hover:bg-accent hover:text-foreground flex-shrink-0',
        chevronSpacer: 'w-6 flex-shrink-0',
        chevronIcon: 'transition-transform duration-200',
        chevronIconOpen: 'transition-transform duration-200 rotate-90',
        levelBadge: 'text-[9px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded border whitespace-nowrap',
        metaRow: 'flex items-center gap-1.5 min-w-0 mt-1',
        tag: 'text-[10px] font-semibold text-muted-foreground bg-muted px-1.5 py-0.5 rounded whitespace-nowrap',
        context: 'text-[11px] text-muted-foreground truncate',
        // Link de drill na linha ("3 conjuntos" → aba Conjuntos filtrada).
        drill: 'text-[11px] font-medium text-violet-600 dark:text-violet-400 hover:underline whitespace-nowrap',
        reason: 'text-[11px] text-muted-foreground/80 italic truncate',
        numCell: 'text-right min-w-0',
        num: 'text-sm font-medium text-foreground tabular-nums truncate',
        numStrong: 'text-[15px] font-semibold text-foreground tabular-nums truncate',
        numMuted: 'text-sm font-medium text-muted-foreground/60 tabular-nums truncate',
        numSub: 'text-[11px] text-muted-foreground truncate',
        totalLabel: 'text-[13px] font-semibold text-foreground',
        totalNum: 'text-sm font-bold text-foreground tabular-nums text-right truncate',
        totalNote: 'text-[11px] text-muted-foreground text-right truncate'
    },

    pageDetail: {
        ...MKT.page,
        container: MKT.page.content,
        card: `${MKT.surface.card} ${MKT.surface.cardPad}`,
        cardTitle: MKT.surface.cardTitle,

        // Cards de alerta derivados dos dados (leitura, nao acao). Borda
        // esquerda grossa carrega o tom; o corpo fica neutro.
        alertGrid: 'grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3',
        alertCard: 'bg-card border border-border border-l-[3px] rounded-xl px-4 py-3.5 flex flex-col gap-1',
        alertTone: {
            danger: { edge: 'border-l-red-600 dark:border-l-red-500', tag: 'text-red-700 dark:text-red-400' },
            warning: { edge: 'border-l-amber-500 dark:border-l-amber-400', tag: 'text-amber-700 dark:text-amber-400' },
            brand: { edge: 'border-l-violet-600 dark:border-l-violet-400', tag: 'text-violet-700 dark:text-violet-400' }
        },
        alertTag: 'text-[11px] font-semibold uppercase tracking-wider',
        alertTitle: 'text-sm font-semibold text-foreground',
        alertBody: 'text-xs leading-relaxed text-muted-foreground',

        // Funil impressoes → cliques → resultado, com a taxa de passagem entre
        // os cards. Em tela estreita os conectores somem e os cards empilham.
        funnelGrid: 'flex flex-col xl:grid xl:grid-cols-[1fr_76px_1fr_76px_1fr] gap-3 xl:gap-0 xl:items-stretch',
        funnelCard: 'border border-border bg-card rounded-xl px-4 py-3.5 flex flex-col gap-1 min-w-0',
        funnelCardResult: 'border-violet-200 dark:border-violet-500/30 bg-violet-50/50 dark:bg-violet-500/5',
        funnelCardDead: 'border-red-200 dark:border-red-500/30 bg-red-50/50 dark:bg-red-500/5',
        funnelLabel: 'text-[11px] font-semibold uppercase tracking-wider text-muted-foreground truncate',
        funnelValue: 'text-[26px] leading-tight font-bold text-foreground tabular-nums tracking-tight truncate',
        funnelSub: 'text-xs text-muted-foreground truncate',
        funnelConnector: 'hidden xl:flex flex-col items-center justify-center gap-1 px-2',
        funnelRate: 'text-[13px] font-bold text-foreground tabular-nums',
        funnelRateLine: 'w-full h-px bg-border',
        funnelRateLabel: 'text-[11px] text-muted-foreground whitespace-nowrap',

        // Tabela de divisao com barra de participacao no gasto. Template unico
        // pra cabecalho/linhas/total; rola na horizontal abaixo do min-width.
        splitCols: 'grid-cols-[minmax(140px,1.3fr)_minmax(170px,1.7fr)_80px_105px_75px]',
        splitMinW: 'min-w-[700px]',
        splitFlag: 'text-[10px] font-semibold px-1.5 py-0.5 rounded border whitespace-nowrap',
        shareTrack: 'flex-1 h-[7px] rounded-full bg-muted overflow-hidden',
        shareFill: 'h-full rounded-full',
        shareSpend: 'text-xs text-muted-foreground tabular-nums whitespace-nowrap w-[104px] text-right',
        splitFootnote: 'px-5 py-3.5 text-xs leading-relaxed text-muted-foreground border-t border-border/60',

        panel: `${MKT.surface.card} px-4 pt-4 pb-1`,
        panelTitle: 'text-[11px] font-semibold uppercase tracking-wider text-muted-foreground pb-2',
        kvRow: 'flex items-baseline justify-between gap-4 py-2.5 border-t border-border/60',
        kvKey: 'text-[13px] text-muted-foreground flex-shrink-0',
        kvValue: 'text-[13px] font-semibold text-foreground text-right break-words min-w-0',
        kvValueMuted: 'text-[13px] font-medium text-muted-foreground text-right break-words min-w-0 tabular-nums',
        subTable: 'w-full text-sm',
        subHead: 'text-[11px] font-semibold uppercase tracking-wider text-muted-foreground bg-muted/40 border-y border-border',
        subHeadCell: 'px-4 py-2.5 text-left font-semibold',
        subHeadCellNum: 'px-4 py-2.5 text-right font-semibold',
        subCell: 'px-4 py-3 text-[13px] text-foreground',
        subCellNum: 'px-4 py-3 text-[13px] text-foreground tabular-nums text-right',
        chartRow: 'h-[150px] w-full'
    }
};
